import { createSlice } from "@reduxjs/toolkit";
import StepActions from "../../constants/stepActions";

const initialData = {
  data: [],
  nextStep: null,
  activeStep: 0,
  dialog: { open: false, finish: false },
};

const stepperSlice = createSlice({
  name: "stepper",
  initialState: [],
  reducers: {
    setInitialData(state, action) {
      const stepperData = {
        ...initialData,
        data: action.payload.steps.map((x, index) => ({
          step: index,
          data: x ?? {},
        })),
        activeStep: action.payload.activeStep,
        name: action.payload.name,
      };
      const stepper = state.find((x) => x.name === action.payload.name);
      if (typeof stepper !== "undefined") {
        stepper.data = stepperData.data;
        stepper.activeStep = stepperData.activeStep;
        stepper.nextStep = stepperData.nextStep;
      } else {
        state.push(stepperData);
      }
    },
    resetData(state, action) {
      const stepper = state.find((x) => x.name === action.payload.name);
      stepper.data = action.payload.steps.map((x, index) => ({
        step: index,
        data: {},
      }));
      stepper.dialog = initialData.dialog;
      stepper.activeStep = initialData.activeStep;
      stepper.nextStep = initialData.nextStep;
    },
    triggerStepChange(state, action) {
      const stepper = state.find((x) => x.name === action.payload.name);
      switch (action.payload.stepAction) {
      case StepActions.NEXT:
        stepper.nextStep = stepper.activeStep + 1;
        break;
      case StepActions.BACK:
        stepper.nextStep = stepper.activeStep - 1;
        break;
      case StepActions.SPECIFIC:
        stepper.nextStep = action.payload.step;
        break;
      default:
        stepper.nextStep = null;
        break;
      }
    },
    changeStep(state, action) {
      const stepper = state.find((x) => x.name === action.payload.name);
      if (typeof action.payload.data !== "boolean") {
        stepper.data = stepper.data.map((stepData) =>
          stepData.step !== stepper.activeStep
            ? stepData
            : { ...stepData, data: action.payload.data }
        );
      }
      const finish = stepper.nextStep > stepper.data.length - 1;
      if (finish) {
        stepper.nextStep = stepper.nextStep - 1;
        stepper.dialog.finish = true;
        stepper.dialog.open = true;
      } else {
        stepper.activeStep = stepper.nextStep;
      }
    },
    closeDialog(state, action) {
      const stepper = state.find((x) => x.name === action.payload.name);
      stepper.dialog = initialData.dialog;
    },
    openDialog(state, action) {
      const stepper = state.find((x) => x.name === action.payload.name);
      stepper.dialog = { open: true, finish: action.payload.finish };
    },
    resetNextStep(state, action) {
      const stepper = state.find((x) => x.name === action.payload.name);
      stepper.nextStep = null;
    },
  },
});

export const stepperActions = stepperSlice.actions;

const goNext = (stepperName) => {
  return (dispatch) => {
    dispatch(
      stepperActions.triggerStepChange({
        stepAction: StepActions.NEXT,
        name: stepperName,
      })
    );
  };
};

const goBack = (stepperName) => {
  return (dispatch) => {
    dispatch(
      stepperActions.triggerStepChange({
        stepAction: StepActions.BACK,
        name: stepperName,
      })
    );
  };
};

export const StepperUtils = {
  goNext,
  goBack,
};

export default stepperSlice.reducer;
